import { isEmpty } from 'lodash';
import {
  ComponentsState,
  ErrorComponentsState,
  Menu,
  Notifications,
  SwitchErrorInfo
} from 'piral';
import * as React from 'react';
import { Link } from 'react-router-dom';

import Header from './components/Header';
import { STORAGE_KEYS } from './Utils/constants';
import { getItem } from './Utils/Storage';

import DashboardContainer from './components/DashboardContainer';
import TokenCheck from './components/TokenCheck';
import { Loading } from './components/UI/loading';
import { useEffect } from 'react';
import { redirectTo } from './Utils/utils';

export const errors: Partial<ErrorComponentsState> = {
  not_found: () => {
    useEffect(() => {
      const appName = getItem(STORAGE_KEYS.APP_NAME);
      const isAuthorised = !isEmpty(getItem(STORAGE_KEYS.AUTH_CONFIG));

      if (appName) {
        redirectTo(`/${appName}`);
      } else if (!isAuthorised) {
        redirectTo('/login');
      } else {
        redirectTo('/');
      }
    }, []);
    return (
      <div>
        <p className='error'>
          Could not find the requested page. Are you sure it exists?
        </p>
        <p>
          Go back <Link to='/'>to the dashboard</Link>.
        </p>
      </div>
    );
  }
};

const color = '#1FAB24';
const size = 'md';
export const layout: Partial<ComponentsState> = {
  LoadingIndicator: () => <Loading />,
  ErrorInfo: (props) => {
    return (
      <div>
        <h1>Error</h1>
        <SwitchErrorInfo {...props} />
      </div>
    );
  },
  DashboardContainer: ({ children }) => (
    <DashboardContainer children={children} />
  ),
  DashboardTile: ({ children }) => {
    return <>{children}</>;
  },
  Layout: ({ children }) => {
    const [d, setD] = React.useState({
      isAuthorised: !isEmpty(getItem(STORAGE_KEYS.AUTH_CONFIG))
    });

    React.useEffect(() => {
      const handlePopSate = () => {
        setD({
          ...d,
          isAuthorised: !isEmpty(getItem(STORAGE_KEYS.AUTH_CONFIG))
        });
      };
      addEventListener('popstate', handlePopSate);

      return () => removeEventListener('popstate', handlePopSate);
    }, []);

    return (
      <div>
        <Notifications />
        <Menu type='general' />
        <Header isAuthorised={d.isAuthorised} />

        <TokenCheck />

        <div
          style={{
            height: 'calc(100vh - 100px)',
            width: '100vw',
            justifyContent: 'center'
          }}
        >
          {children}
        </div>
      </div>
    );
  },

  NotificationsHost: ({ children }) => (
    <div className='notifications'>{children}</div>
  ),
  NotificationsToast: ({ options, onClose, children }) => (
    <div className={`notification-toast ${options.type}`}>
      <div className='notification-toast-details'>
        {options.title && (
          <div className='notification-toast-title'>{options.title}</div>
        )}
        <div className='notification-toast-description'>{children}</div>
      </div>
      <div className='notification-toast-close' onClick={onClose} />
    </div>
  )
};
